import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

export default class extends BaseStore {
  #name = 'FeatureSectionStore';
  indicatorSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      initialSlide: this.activeIndex,
      // loop: true,
      direction: 'horizontal',
      slidesPerView: 3,
      spaceBetween: 20,
      // centerInsufficientSlides: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      on: {
        click: event => {
          const index = event.target.closest('.swiper-slide')?.getAttribute('data-swiper-slide-index');
          if (index !== null && index !== undefined) {
            this.toSlideWithIndex(+index);
          }
        }
      }
    }
  });
  lastMoveX = 0;
  pageSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      on: {
        init: () => {},
        touchStart: ev => {
          this.lastMoveX = ev.clientX;
        },
        sliderMove: ev => {
          const { clientX } = ev;
          if (clientX < this.lastMoveX) {
            this.slideNext();
          } else if (clientX > this.lastMoveX) {
            this.slidePrev();
          }
          this.lastMoveX = clientX;
        }
      },
      allowTouchMove: this.featureList.length > 1
    },
    onSlideChange: realIndex => {
      this.activeIndex = realIndex;
      this.indicatorSwiperStore.onChange(this.activeIndex);
      // this.indicatorSwiperStore.onChange(this.activeIndex - 1);
    }
  });

  @observable activeIndex = 0;
  // 特色列表
  @observable
  featureList = [
    {
      title: 'feature2',
      img: require('./images/img-feature2.jpg'),
      label: '极致视觉',
      tabImg: require('./images/tab-img-feature2.png'),
      tabActiveImg: require('./images/tab-active-img-feature2.png')
    },
    {
      title: 'feature3',
      img: require('./images/img-feature3.jpg'),
      label: '畅快游戏',
      tabImg: require('./images/tab-img-feature3.png'),
      tabActiveImg: require('./images/tab-active-img-feature3.png')
    },
    {
      title: 'feature1',
      img: require('./images/img-feature1.jpg'),
      label: '数据互通',
      tabImg: require('./images/tab-img-feature1.png'),
      tabActiveImg: require('./images/tab-active-img-feature1.png')
    }
  ];
  slidePrev = () => {
    let nextIndex = this.activeIndex - 1;
    if (nextIndex < 0) {
      nextIndex = this.featureList.length - 1;
    }
  };
  slideNext = () => {
    let nextIndex = this.activeIndex + 1;
    if (nextIndex > this.featureList.length - 1) {
      nextIndex = 0;
    }
  };
  toSlide = mechaId => {
    const idx = this.featureList.findIndex(i => i.id === mechaId);
    idx !== void 0 && this.pageSwiperStore.onChange(+idx);
  };
  toSlideWithIndex = index => {
    this.activeIndex = index;
    this.pageSwiperStore.onChange(index);
  };
  goPrev = () => {
    this.pageSwiperStore.goPrev();
  };
  goNext = () => {
    this.pageSwiperStore.goNext();
  };

  constructor(props) {
    super();

    Object.assign(this, props);
  }

  use() {
    super.use();
  }
}
